import { NgModule } from '@angular/core';
import { TopNavBarComponent } from './components/top-nav-bar/top-nav-bar.component';
import { SideNavBarComponent } from './components/side-nav-bar/side-nav-bar.component';
import { ThirdPartyModule } from '../third-party/third-party.module';
import { SharedModule } from '../shared/shared.module';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NavToggleButtonComponent } from './components/nav-toggle-button/nav-toggle-button.component';
import { ProductMenuComponent } from './components/product-menu/product-menu.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    declarations: [
        TopNavBarComponent,
        SideNavBarComponent,
        NavToggleButtonComponent,
        ProductMenuComponent,
    ],
    imports: [
        ThirdPartyModule,
        SharedModule,
        CommonModule,
        RouterModule,
        MatMenuModule,
        MatIconModule,
    ],
    exports: [TopNavBarComponent, SideNavBarComponent, NavToggleButtonComponent],
})
export class MasterNavigationModule {}
